var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex-wrap" }, [
    _c(
      "div",
      { staticClass: "w-full md:w-3/4 md:pr-20" },
      [
        _c("h1", { staticClass: "mt-2 mb-4 font-sans text-n-gray-dark" }, [
          _vm._v("Organization Details"),
        ]),
        _vm._v(" "),
        _c("organization-edit"),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "w-full md:w-1/4 md:pt-40" }, [
      _c(
        "div",
        { staticClass: "sidebar-block border-t-5 border-black pt-3" },
        [
          _c("public-profile-link"),
          _vm._v(" "),
          _c("h2", { staticClass: "text-lg mb-5 font-sans text-n-gray-dark" }, [
            _vm._v("Help with Public Profile"),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("support"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "list-reset mb-10 text-base" }, [
      _c("li", { staticClass: "mb-2" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://help.letsreimagine.org/hc/en-us/sections/360008463452-Creating-your-account-and-public-profile",
            },
          },
          [_vm._v("Profile and Account Guide")]
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "mb-2" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://help.letsreimagine.org/hc/en-us/articles/360041721452-Example-public-profile",
            },
          },
          [_vm._v("Example Profile Page")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }